/** Textos de pantalla de éxito Correos (ES). */
export const correosEsSuccessCopy = {
  tabParticular: 'Particular',
  tabEmpresa: 'Empresa',
  searchPlaceholder: 'Busca en correos.es',
  title: 'Seguimiento de Correos',
  trackingLabel: 'El número de rastreo:',
  copy: 'Copiar',
  statusTitle: 'Estado del paquete',
  statusLine1: 'Los datos del paquete han sido introducidos en el sistema de Correos.',
  statusLine2: 'Pago anticipado realizado por el destinatario.',
  productInfoTitle: 'Información del Producto',
  deliveryAddress: 'Dirección de entrega:',
  characteristics: 'Características:',
  characteristicsValue: 'Recoger en la entrega',
  description: 'Descripción:',
  amountToReceive: 'Cantidad a recibir:',
  helpTitle: '¿Necesitas más ayuda?',
  helpBody: 'Póngase en contacto con el soporte de seguimiento de Correos para obtener más ayuda.',
  faqs: 'FAQs',
  cta: 'OBTENER DINERO',
  loading: 'Cargando…',
};

